module.exports = __webpack_public_path__ + "img/news2-4.3d63bd25.png";